import { EngagementType } from '@/generated/graphql';
import { EngagementDefinition } from './base/EngagementDefinition';

import { photoCarouselEngagementDefinition } from './photo-carousel/definition';
import { voteForEngagementDefinition } from './vote-for/definition';
import { slidesEngagementDefinition } from './slides/definition';
import { nowPlayingEngagementDefinition } from './now-playing/definition';
import { raffleEngagementDefinition } from './raffle/definition';
import { triviaEngagementDefinition } from './trivia/definition';

export const engagementDefinitionsArray = [
  photoCarouselEngagementDefinition,
  voteForEngagementDefinition,
  slidesEngagementDefinition,
  nowPlayingEngagementDefinition,
  raffleEngagementDefinition,
  triviaEngagementDefinition,
];

export const engagementDefinitions = engagementDefinitionsArray.reduce(
  (acc, definition) => {
    acc[definition.type] = definition;
    return acc;
  },
  {} as Record<EngagementType, EngagementDefinition<any, any>>,
);
